import Event from './event'
const EventBus = new Event()

export default EventBus
